import React, { useEffect, useRef, useState } from "react";
import { getApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import DateInput from "../../components/common/inputs/DateInput";
import UserModal from "../../components/common/modals/user-modal/UserModal";
import { PiXFill } from "react-icons/pi";

function Export() {
  const [exporting, setExporting] = useState(false);
  const [fromPaymentDate, setFromPaymentDate] = useState(null);
  const [toPaymentDate, setToPaymentDate] = useState(null);
  const [isExportProccessShipping, setIsExportProccessShipping] = useState(0);

  const exportOrders = async () => {
    if (exporting) return;
    const path = "admin/exports/exportOrders";
    const params = {
      fromPaymentDate: fromPaymentDate ? fromPaymentDate : undefined,
      toPaymentDate: toPaymentDate ? toPaymentDate : undefined,
      isExportProccessShipping,
      user: user?._id || "",
    };
    try {
      setExporting(true);
      const response = await getApi({ path, params, responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `orders_${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
    } catch (error) {
      console.log(error);
      let message = "دریافت خروجی سفارش‌ها انجام نشد.";
      if (error?.response?.data instanceof Blob) {
        try {
          const body = JSON.parse(await error.response.data.text());
          message = body?.errors?.[0]?.message || message;
        } catch (_) {}
      } else {
        message = error?.response?.data?.errors?.[0]?.message || message;
      }
      errorMessage(message);
    } finally {
      setExporting(false);
    }
  };

  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!show) {
      setFromPaymentDate(null);
      setToPaymentDate(null);
    }
  }, [show]);

  const userModalRef = useRef();

  const [user, setUser] = useState(null);
  const [userInfo, setUserInfo] = useState(null);

  const handleUser = (data) => {
    setUser(data);
    setUserInfo(data?.name || data?.mobile);
    successMessage(`کاربر ${data?.name || data?.mobile} انتخاب شد`);
  };

  const deleteUser = () => {
    setUser(null);
    setUserInfo("");
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />
      <div className="flex items-center justify-between">
        <h3 className="text-xl text-gray-800 dark:text-white">خروجی دیتا</h3>
        <label className="inline-flex gap-2 items-center cursor-pointer">
          <span className="text-sm font-medium text-gray-900 dark:text-gray-300">
            استفاده از تاریخ
          </span>
          <input
            type="checkbox"
            value={show}
            onChange={() => setShow(!show)}
            className="sr-only peer"
          />
          <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
        </label>
      </div>
      <div className="flex items-center justify-center md:justify-start flex-wrap gap-2 mt-4">
        {show ? (
          <>
            <DateInput label={"از تاریخ"} onChange={setFromPaymentDate} />
            <DateInput label={"تا تاریخ"} onChange={setToPaymentDate} />
          </>
        ) : null}

        <div className="relative">
          <span
            onClick={() => userModalRef?.current?.showModal()}
            className="absolute w-full h-full"
          ></span>
          {user ? (
            <PiXFill
              className=" cursor-pointer absolute left-2 bottom-4 text-red-500"
              onClick={deleteUser}
            />
          ) : null}
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            انتخاب کاربر
          </label>
          <input
            value={userInfo}
            onChange={(e) => setUserInfo(e.target.value)}
            disabled
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            وضعیت پرداخت
          </label>
          <select
            value={isExportProccessShipping}
            onChange={(e) => setIsExportProccessShipping(e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value={0}>بدون تغییر وضعیت</option>
            <option value={1}>تغیر وضعیت به در حال بسته بندی</option>
          </select>
        </div>

        <button
          className="admin-button mt-7 rounded-lg bg-blue-700 px-6 py-2.5 text-sm text-white hover:bg-blue-800 disabled:cursor-wait disabled:opacity-60"
          type="button"
          onClick={exportOrders}
          disabled={exporting}
        >
          {exporting ? "در حال آماده‌سازی خروجی..." : "دریافت خروجی اکسل"}
        </button>
      </div>
    </div>
  );
}

export default Export;
